import { FIREBALL, PALETTE } from '@blorbs/common';
import type { FireballState } from '@blorbs/common';
import type { Camera } from './camera';
import { circle, inkStroke } from './art';

const FIRE = PALETTE[3]; // orange
const CORE = PALETTE[4]; // butter

/** Over the last stretch of its range the fireball shrinks and fades so the fizzle isn't a surprise. */
const FADE_DISTANCE = 120;

export function drawFireball(ctx: CanvasRenderingContext2D, cam: Camera, f: FireballState, time: number): void {
  const fade = Math.min(1, Math.max(0.15, f.left / FADE_DISTANCE));
  const r = FIREBALL.radius * (0.55 + 0.45 * fade);
  const flicker = 1 + Math.sin(time * 40 + f.id) * 0.08;
  ctx.save();
  ctx.globalAlpha = 0.35 + 0.65 * fade;

  ctx.fillStyle = FIRE;
  circle(ctx, f.x, f.y, r * flicker);
  ctx.fill();
  inkStroke(ctx, 2.4, cam.scale);
  ctx.stroke();

  ctx.fillStyle = CORE;
  circle(ctx, f.x - f.dx * 1.5, f.y - f.dy * 1.5, r * 0.48 * flicker);
  ctx.fill();
  ctx.restore();
}
